import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PreviewLarkStyle from "@/pages/PreviewLarkStyle";

export const Route = createFileRoute("/preview/lark-style")({
  head: () => seoHead("/preview/lark-style"),
  component: PreviewLarkStyle,
});
